import axios from "axios";
import authHeader from '../../../authheader'

const VFAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/FirmVfApplication";



const getBoardRecommendations = (applicationId) => {
    return axios.get(`${VFAPPLICATIONURL}/boardrecommendations`, { headers: authHeader(), params: { applicationId } });
}
const getBoardResponses = (applicationId) => {
    return axios.get(`${VFAPPLICATIONURL}/boardmemberresponses`, { headers: authHeader(), params: { applicationId } });
}
const postBoardRecommendation = (data) => {
    return axios.post(`${VFAPPLICATIONURL}/boardrecommendation`, data, { headers: authHeader() });
}
const postBoardResponse = (data) => {
    var header = authHeader();
    header['Content-Type'] = 'multipart/form-data';
    return axios.post(`${VFAPPLICATIONURL}/boardmemberresponse`, data, { headers: { ...header } });
}
export default {
    getBoardRecommendations,
    getBoardResponses,
    postBoardRecommendation,
    postBoardResponse
}